const style = (theme) => {
  const output = {
    root: {
      height: 'var(--vh)',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    hero: {
      padding: '0 4.15vw',
      '& h1': {
        fontSize: 150,
        fontWeight: 500,
        lineHeight: 1,
        transform: 'translateY(100%)',
        transition: `all 1.5s ${theme.easings['power4.out']}`,
      },
      '& h2': {
        fontSize: 65,
        fontWeight: 500,
        lineHeight: 1,
        transform: 'translateY(-100%)',
        transition: `all 1.5s 0.7s ${theme.easings['power4.out']}`,
        '& strong': {
          fontWeight: 400,
          fontFamily: theme.fonts[1],
        },
      },
    },
    overflowHidden: {
      overflow: 'hidden',
    },
    y0: {
      transform: 'translateY(0%) !important',
    },
    scrollDown: {
      position: 'absolute',
      bottom: 0,
      left: '4.15vw',
      opacity: 0,
      pointerEvents: 'none',
      transition: 'all 1s 1s ease',
      transform: 'translateX(-50%)',
    },
    scrollDownVisible: {
      opacity: 1,
      pointerEvents: 'all',
    },
    secondLine: {
      display: 'flex',
      '& *:not(:first-child)': {
        marginLeft: 18,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    root: {
      height: 'var(--vh-fixed)',
    },
    hero: {
      width: '100%',
      extend: theme.wrapper,
      '& h1': {
        fontSize: '17.6vw',
      },
      '& h2': {
        fontSize: '18.2vw',
        transform: 'translateY(100%)',
        transition: `all 1.5s ${theme.easings['power4.out']}`,
        '& strong': {
          fontSize: '13.8vw',
          transition: `all 1.5s ${theme.easings['power4.out']}`,
        },
      },
    },
    scrollDown: {
      left: 30,
      transform: 'translateX(0%)',
    },
    secondLine: {
      display: 'block',
      '& *:not(:first-child)': {
        marginLeft: 0,
        marginTop: 6,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
